import { AccordionDesignTokens } from "@primeuix/themes/types/accordion"

const index: AccordionDesignTokens = {
  header: {
    background: 'transparent',
    hoverBackground: 'transparent',
    activeBackground: 'transparent',
    activeHoverBackground: 'transparent'
  },
  content: {
    background: 'transparent'
  }
}

export { index as default }
